import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewListSignataireComponent } from './view-list-signataire.component';

import { NgxPaginationModule } from 'ngx-pagination';
import { AddCasierModule } from '../add-casier/add-casier.module';
import { VisualizeCasierModule } from '../visualize-casier/visualize-casier.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ViewDetailsCasierModule } from '../view-details-casier/view-details-casier.module';


@NgModule({
  declarations: [
    ViewListSignataireComponent
  ],
  imports: [
    CommonModule,
    NgxPaginationModule,
    AddCasierModule,
    VisualizeCasierModule,
    ReactiveFormsModule,
    FormsModule,
  ]
})
export class ViewListSignataireModule { }
